"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.repeat_guesses = void 0;

function repeat_guesses(match) {
  return match.base_guesses * match.repeat_count;
}

exports.repeat_guesses = repeat_guesses;